import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../../../app/applicationSlice'
import { RootState, RootThunkApi } from '../../../../app/store'
import * as T from '../../../../services/TraceCodeFlow'

export const getTraceCodeFlowList = createAsyncThunk<
  void,
  T.TraceCodeFlowListParams,
  RootThunkApi
>('payment/getTraceCodeFlowList', async (params, api) => {
  return sendAsync(T.TraceCodeFlowList(params), api)
})

// 详情导出
export const getTraceCodeFlowExportAsync = createAsyncThunk<
  void,
  T.TraceCodeFlowListParams,
  RootThunkApi
>('doctorAudit/getTraceCodeFlowExport ', async (params, api) => {
  return sendAsync(T.getTraceCodeFlowExport(params), api)
})
